<template>
  <div class="app-container">
    <CrudTable entity="Language" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: ['code', 'description']
    };
  },
  methods: {
    generateSummary({ code, description }) {
      let summary = `${code}`;
      if (description) {
        summary += ` (${description})`;
      }
      return summary;
    }
  }
};
</script>
